var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoReported(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 47.5 47.5",
    xmlns: "http://www.w3.org/2000/svg",
    id: "r",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 38h38V0H0v38Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.25 0 0 -1.25 0 47.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#689689",
    d: "M37 5a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v28a4 4 0 0 0 4 4h28a4 4 0 0 0 4-4V5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.428 20.31h3.193c1.705 0 2.885 1.023 2.885 2.759 0 1.767-1.18 2.729-2.885 2.729h-3.193V20.31Zm-4.651 7.348c0 1.488.837 2.419 2.387 2.419h5.457c4.775 0 7.721-2.14 7.721-7.008 0-3.41-2.574-5.363-5.737-5.86l5.272-5.643c.433-.465.619-.93.619-1.364 0-1.209-.961-2.387-2.324-2.387-.559 0-1.303.217-1.799.806l-6.883 8.34h-.062v-6.728c0-1.551-.992-2.418-2.326-2.418-1.333 0-2.325.867-2.325 2.418v17.425z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoReported);
export default __webpack_public_path__ + "static/media/ico-reported.81b281768ddf1cb9bbfcd1ccdac7382d.svg";
export { ForwardRef as ReactComponent };